// Place (Adresář) registry types — CHR-06 / ID-236, mirroring the api DTOs in
// the LOCKED contract (`docs/superpowers/plans/2026-09-16-chr06-address-database.md`
// §C). Five free-text business fields 1:1 with the client's `Kontakty kampaň.xlsx`
// (název · adresa · kontakt · poznámka) plus the type. Nothing is parsed
// server-side: phones are recognised in the UI only (`utils/phone.ts`).

export type PlaceType = 'LOADING' | 'UNLOADING' | 'BOTH';

// Render order for the type filter / editor toggle (Nakládka · Vykládka · Obojí).
export const PLACE_TYPES: readonly PlaceType[] = ['LOADING', 'UNLOADING', 'BOTH'];

export interface PlaceDto {
  id: string;
  version: number;
  name: string;
  type: PlaceType;
  address: string | null;
  contact: string | null;
  note: string | null;
  deleted: boolean;
  createdAt: string;
  updatedAt: string;
}

// Place projection — BOTH the `GET /api/places/autocomplete` rows AND the
// `loadingPlaceRecord` / `unloadingPlaceRecord` fields the jízda detail carries
// (§E). `note` is load-bearing, NOT decoration: the jízda editor (W2) appends
// it to „Poznámka pro dispečera" on selection.
//
// `contact` joined the projection on 2026-09-18. It never enters a jízda FIELD,
// but it IS part of the SMS block the editor's „vykopírovat celý řádek
// z Adresáře" button writes to the clipboard — and that click must be a pure
// in-memory copy of the record the detail already holds (user: „proč se volá EP
// autocomplete, když kliknu na zkopírovat? ty data už by měla být načtena
// v detailu"). A projection without `contact` would force back exactly the
// per-click `GET /api/places/{id}` that was rejected. `PlaceDto` stays the only
// shape carrying `version` / `deleted` / the timestamps.
export interface PlaceSummary {
  id: string;
  name: string;
  type: PlaceType;
  address: string | null;
  contact: string | null;
  note: string | null;
}

export interface PlaceCreate {
  name: string;
  type: PlaceType;
  address: string | null;
  contact: string | null;
  note: string | null;
}

// Full replace — a `null` CLEARS the column server-side (contract §C).
export interface PlaceUpdate extends PlaceCreate {
  version: number;
}

// `OffsetPageResponse<PlaceDto>` envelope (ADR-0044). `page` is 0-based and
// maps DIRECTLY onto the `?page=` param — no off-by-one translation.
export interface PlacePage {
  content: PlaceDto[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}
